import type { RangeModifier } from '@looker/components';
import { addDays, format, parseISO, subDays } from 'date-fns';
import { DATE_RANGE_OPTIONS, type DateRangeOption } from '../modules/HCPSiteWorkspaceView/helpers/constants';

export const DATE_RANGE_DELIMITER = /\s*,\s*|\s+to\s+/;

export const formatDateForLooker = (date: Date) => format(date, 'yyyy/MM/dd');

export const isValidDate = (value: string) => !Number.isNaN(Date.parse(value));

export const formatCustomRangeForLooker = (range: RangeModifier): string => {
  if (range.from && range.to) {
    const toDatePlusOne = addDays(range.to, 1);
    return `${formatDateForLooker(range.from)} to ${formatDateForLooker(toDatePlusOne)}`;
  }
  return '';
};

export const isPresetOption = (value: string | undefined): value is DateRangeOption => {
  return DATE_RANGE_OPTIONS.some((option) => option.value === value);
};

export const getESTToday = (): Date => {
  const now = new Date();
  const estString = now.toLocaleDateString('en-CA', {
    timeZone: 'America/New_York',
  });
  return parseISO(estString);
};

export const parseDateRange = (value: string) => {
  const [from, to] = value.split(DATE_RANGE_DELIMITER);

  const isFromDateValid = isValidDate(from);
  const isToDateValid = isValidDate(to);
  const fromDate = isFromDateValid ? new Date(from) : subDays(getESTToday(), 7);
  const toDate = isToDateValid ? new Date(to) : isFromDateValid ? fromDate : addDays(fromDate, 6);

  return {
    from: fromDate,
    to: toDate,
  };
};

export const formatDateRange = (range: RangeModifier) => {
  if (!range.from) return '';
  return `${formatDateForLooker(range.from)} to ${formatDateForLooker(range.to ?? range.from)}`;
};
